import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  size?: 'md' | 'lg';
  variant?: 'solid' | 'outline';
  className?: string;
};
export function CtaButton({
  label,
  size = 'lg',
  variant = 'solid',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-4 text-base sm:text-lg' : 'px-5 py-3 text-sm';
  const look = variant === 'solid' ? 'bg-safety text-carbon-950 hover:bg-[#ff9f2e] shadow-[0_0_0_1px_rgba(255,140,0,0.6),0_16px_40px_-16px_rgba(255,140,0,0.7)]' : 'bg-transparent text-white border border-carbon-600 hover:border-volt hover:text-volt';
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex items-center justify-center gap-2 rounded-md font-bold tracking-tight transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-volt focus-visible:ring-offset-2 focus-visible:ring-offset-carbon-950 ${sizing} ${look} ${className}`} data-id="element-11" data-mp="vbk39xln7r1k">
      <span data-id="element-12" data-mp="39yrgxlaii6mp">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-13" data-mp="39y7zs6sorm9q" />
    </a>;
}